import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class WebapiService {

  // private url = 'http://localhost:3000/api/v1';
  // public imageUrl = 'http://localhost:3000/public/images/';
  // public reportUrl = 'http://localhost:3000/public/gen-report/';
  // public inviteUrl = "http://localhost:4500/"
  public s3Url = "https://foxi-uploads.s3.us-east-1.amazonaws.com/";


  private url = 'http://bgverp.foxivision.com:3000/api/v1/';
  public imageUrl = 'http://bgverp.foxivision.com:3000/public/images/';
  public reportUrl = 'http://bgverp.foxivision.com:3000/public/gen-report/';
  public inviteUrl = "http://bgvapp.foxivision.com/"

  // private url = 'https://foxoglobal.com/api';
  // public imageUrl = 'https://foxoglobal.com/public/images/';
  // public reportUrl = 'https://foxoglobal.com/public/gen-report/';
  // public inviteUrl = "https://foxoglobal.com/"

  constructor(private http: HttpClient) { }

  isLogedIn() {
    // localStorage survives page refresh; sessionStorage is wiped on F5
    return localStorage.getItem('loginId') || sessionStorage.getItem('loginId');
  }

  insertUser(data: any) {
    return this.http.post(this.url + "/createUpdateUser", data);
  }
  insertInsufLog(data: any) {
    return this.http.post(this.url + "/createUpdateInsufLog", data);
  }
  insertTaskLog(data: any) {
    return this.http.post(this.url + "/createUpdateTaskLog", data);
  }
  exportFile(data: any) {
    return this.http.post(this.url + "/export", data, { responseType: 'arraybuffer' });
  }
  exportInsufData(data: any) {
    return this.http.post(this.url + "/exportInsufData", data, { responseType: 'arraybuffer' });
  }
  exportInsufClearedData(data: any) {
    return this.http.post(this.url + "/exportInsufClearedData", data, { responseType: 'arraybuffer' });
  }

  exportMisReport(data: any) {
    return this.http.post(this.url + "/exportClientMisDataV2", data, { responseType: 'arraybuffer' });
  }
  exportBillData(data: any) {
    return this.http.post(this.url + "/exportBillData", data, { responseType: 'arraybuffer' });
  }
  getAllUser(id = "") {
    return this.http.get(this.url + "/getAllUser" + id);
  }
  getUserById(id: any) {
    // let cacheBustingValue = new Date().getTime();
    return this.http.get(this.url + "/getUser/" + id);
  }
  getUserByType(id: any) {
    // let cacheBustingValue = new Date().getTime();
    return this.http.get(this.url + "/getUserByType/" + id);
  }
  deleteUser(data) {
    return this.http.post(this.url + "/deleteUser/", data);
  }
  insertTeam(data: any) {
    return this.http.post(this.url + "/createUpdateTeam", data);
  }
  getFullReportApp(data: any) {
    return this.http.post(this.url + "/getFullReportApp", data);
  }
  ExportFullReportApp(data: any) {
    return this.http.post(this.url + "/ExportFullReportApp", data, { responseType: 'arraybuffer' });
  }
  getAllTeam(id = "") {
    return this.http.get(this.url + "/getAllTeam" + id);
  }
  getTeamById(id) {
    return this.http.get(this.url + "/getTeam/" + id);
  }
  deleteTeam(data: any) {
    return this.http.post(this.url + "/deleteTeam", data);
  }
  insertCheck(data: any) {
    return this.http.post(this.url + "/setting", data);
  }
  getAllCheck(id = "") {
    return this.http.get(this.url + "/setting" + id);
  }
  getAllManager(id = "") {
    return this.http.get(this.url + "/getAllManager" + id);
  }

  uploadImage(data: any) {
    return this.http.post(this.url + "/uploadImage", data);
  }
  uploadMedia(data: any) {
    return this.http.post(this.url + "/uploadMedia", data);
  }
  uploadZipS3(data: any) {
    return this.http.post(this.url + "/uploadZipS3", data);
  }
  uploadMultipleImage(data: any) {
    return this.http.post(this.url + "/uploadMultipleImage", data);
  }
  getAppCount(id) {
    return this.http.get(this.url + "/getAppCount/" + id);
  }

  doLogin(data: any) {
    return this.http.post(this.url + "/doLogin", data);
  }
  ///////////////////for application page
  getApplicationdetail(data: any) {
    return this.http.post(this.url + "/getApplicationdetail", data);
  }
  getAllClient(id = '') {
    return this.http.get(this.url + "/getAllClient");
  }
  getProcessChecksByClient(data: any) {
    return this.http.post(this.url + "getProcessChecksByClient", data);
  }
  getProcessChecks(data: any) {
    return this.http.post(this.url + "/getApplicationdetail", data);
  }
  getBothColumnByTable(data: any) {
    return this.http.post(this.url + "/getBothColumnByTable", data);
  }
  getColumnByTableIns(data: any) {
    return this.http.post(this.url + "/getColumnByTableIns", data);
  }
  insertApplication(data: any) {
    return this.http.post(this.url + "/createUpdateAppV2", data);
  }
  createReportLog(data: any) {
    return this.http.post(this.url + "/createReportLog", data);
  }
  getAllReportLogByAppId(data: any) {
    return this.http.post(this.url + "/getAllReportLogByAppId", data);
  }
  getInsuffApplications(data: any) {
    return this.http.post(this.url + "/getInsuffApplications", data);
  }
  getInsuffClearApplications(data: any) {
    return this.http.post(this.url + "/getInsuffClearApplications", data);
  }
  getAllApplication(data: any) {
    return this.http.post(this.url + "/application", data);
  }
  getAllApplicationInit(data: any) {
    return this.http.post(this.url + "/applicationInit", data);
  }
  getAllApplicationByEmp(data: any) {
    return this.http.post(this.url + "/getAllApplicationByEmp", data);
  }
  getAllUsersV2(data: any) {
    return this.http.post(this.url + "/getAllUsersV2", data);
  }
  getAllSpocByClientWithTaskLog(data: any) {
    return this.http.post(this.url + "/getAllSpocByClientWithTaskLog", data);
  }
  getAllSpocByClient(data: any) {
    return this.http.post(this.url + "/getAllSpocByClient", data);
  }
  getAllTaskLog(data: any) {
    return this.http.post(this.url + "/getAllTaskLog", data);
  }
  getAppById(id) {
    return this.http.get(this.url + "/application/" + id);
  }

  getAllCountData(data: any) {
    return this.http.post(this.url + "/getAllCountData", data);
  }
  getAllCountDataInit(id = "") {
    return this.http.get(this.url + "/getAllCountDataInit" + id);
  }
  getAllCountDataV2(id = "") {
    return this.http.get(this.url + "/getAllCountDataV2" + id);
  }
  getClientWithCount(id = "") {
    return this.http.get(this.url + "/getClientWithCount" + id);
  }
  getMonthWiseData(data: any) {
    return this.http.post(this.url + "/getMonthWiseData", data);
  }
  getApplicationCountByStatus(data: any) {
    return this.http.post(this.url + "/getApplicationCountByStatus", data);
  }
  getApplicationCountByStatusInit(data: any) {
    return this.http.post(this.url + "/getApplicationCountByStatusInit", data);
  }
  getApplicationCountByStatusByEmp(id = "") {
    return this.http.get(this.url + "/getApplicationCountByStatusByEmp" + id);
  }

  inviteEmail(data: any) {
    return this.http.post(this.url + "/inviteEmail", data);
  }
  getApplicationByStatus(data: any) {
    return this.http.post(this.url + "/getApplicationByStatus", data);
  }
  getCheckByStatus(data: any) {
    return this.http.post(this.url + "/getCheckByStatus", data);
  }
  getApplicationByFilter(data: any) {
    return this.http.post(this.url + "/getApplicationByFilter", data);
  }
  getApplicationBySearch(data: any) {
    return this.http.post(this.url + "/getApplicationBySearch", data);
  }
  getCheckBySearch(data: any) {
    return this.http.post(this.url + "/getCheckBySearch", data);
  }
  getCheckByFilter(data: any) {
    return this.http.post(this.url + "/getCheckByFilter", data);
  }
  getCountBySearch(data: any) {
    return this.http.post(this.url + "/getCountBySearch", data);
  }
  getCountByFilter(data: any) {
    return this.http.post(this.url + "/getCountByFilter", data);
  }

  getClientCount(data: any) {
    return this.http.post(this.url + "/getClientCount", data);
  }

  uploadApplicationExcel(data: any) {
    return this.http.post(this.url + "/uploadApplicationExcel", data);
  }
  updateApplicationExcel(data: any) {
    return this.http.post(this.url + "/updateApplicationExcel", data);
  }
  uploadCheckExcel(data: any) {
    return this.http.post(this.url + "/uploadCheckExcel", data);
  }

  getApplications(data: any) {
    return this.http.post(this.url + "/getApplications", data);
  }
  getApplicationsInit(id) {
    return this.http.get(this.url + "/getApplicationsInit", id);
  }
  getApplicationsEmp(id) {
    return this.http.get(this.url + "/getApplicationsEmp", id);
  }

  getApplicationById(id: any) {
    return this.http.get(this.url + "/application/" + id);
  }
  getAppByEmpIdV2(id: string) {
    return this.http.get(this.url + "/getAppByEmpIdV2/" + id, {
      headers: {
        'api_key': 'Foxi#1234'
      }
    });
  }
  getApplicationByIdInvite(id) {
    return this.http.get(this.url + "/applicationInvite/" + id);
  }

  genrateReport(data: any) {
    return this.http.post(this.url + "/generatePdf", data);
  }

  getClientMisCount(data: any) {
    return this.http.post(this.url + "/getClientMisCount/", data);
  }
  getMisClientDataAll(data: any) {
    return this.http.post(this.url + "/getMisClientDataAll/", data);
  }
  getClientApplicationCount(data: any) {
    return this.http.post(this.url + "/getClientApplicationCount/", data);
  }
  getApplicationDataAll(data: any) {
    return this.http.post(this.url + "/getApplicationDataAll/", data);
  }
  getClientMisData(data: any) {
    return this.http.post(this.url + "/getClientMisData/", data);
  }

  getClientMisChecksData(data: any) {
    return this.http.post(this.url + "/getClientMisChecksData/", data);
  }

  updateAppStatus(data: any) {
    return this.http.post(this.url + "/updateAppStatus/", data);
  }

  updateAppMisStatus(data: any) {
    return this.http.post(this.url + "/updateAppRemarkMis/", data);
  }

  trackUser(data: any) {
    return this.http.post(this.url + "/track/", data);
  }


}
